import { render, staticRenderFns } from "./the-header-help-popover.vue?vue&type=template&id=fe03ef4e&scoped=true"
import script from "./the-header-help-popover.vue?vue&type=script&lang=js"
export * from "./the-header-help-popover.vue?vue&type=script&lang=js"
import style0 from "./the-header-help-popover.vue?vue&type=style&index=0&id=fe03ef4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe03ef4e",
  null
  
)

export default component.exports